import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { colors } from '@mui/material';

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
    fontSize: 16,
    width: '100%',
    padding: '10px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
    '&::placeholder': { // Adding placeholder styles here
      color: '#666666',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '20px',
    },
  },
}));

function BootstrapTextField({ label, defaultValue, id,onChange , ...rest }) {
  return (
    <FormControl variant="standard" fullWidth>
      <InputLabel shrink htmlFor={id}>
        {label}
      </InputLabel>
      <BootstrapInput {...rest} onChange={onChange} style={{width:'100%',backgroundColor:'white'}} defaultValue={defaultValue} id={id} />
    </FormControl>
  );
}

export default BootstrapTextField;
